import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'braintree',
  scriptId: 'braintree-js',
  makeScriptUri: () => `https://js.braintreegateway.com/web/3.85.3/js/client.min.js`
})

const installHostedFields = composeInstallation({
  name: 'braintree-hostedFields',
  scriptId: 'braintree-hosted-fields-js',
  makeScriptUri: () => `https://js.braintreegateway.com/web/3.85.3/js/hosted-fields.min.js`
})

const installPaypalCheckout = composeInstallation({
  name: 'braintree-paypal',
  scriptId: 'braintree-paypal-js',
  makeScriptUri: () => `https://js.braintreegateway.com/web/3.85.3/js/paypal-checkout.min.js`
})

const installApplePay = composeInstallation({
  name: 'braintree-apple',
  scriptId: 'braintree-apple-js',
  makeScriptUri: () => `https://js.braintreegateway.com/web/3.85.3/js/apple-pay.min.js`
})

const installGooglePay = () => Promise.all([
  composeInstallation({
    name: 'google-pay',
    scriptId: 'google-pay-js',
    makeScriptUri: () => `https://pay.google.com/gp/p/js/pay.js`
  })(),
  composeInstallation({
    name: 'braintree-google',
    scriptId: 'braintree-google-js',
    makeScriptUri: () => `https://js.braintreegateway.com/web/3.85.3/js/google-payment.min.js`
  })()
])

export { install, installHostedFields, installPaypalCheckout, installApplePay, installGooglePay }